import http from "../../http"

const BASE = "/gateway/api/sycompany/pc/CompanyStallBillPC"

const stallBill = {
  listStallCompanies(r) {
    return http.get(`${BASE}/listStallCompanies`, r)
  },
  selectDailyPage(r) {
    return http.spin.get(`${BASE}/selectDailyPage`, r)
  },
  selectDailyDetail(r) {
    return http.get(`${BASE}/selectDailyDetail`, r)
  },
  selectOrderPage(r) {
    return http.spin.get(`${BASE}/selectOrderPage`, r)
  },
  recalc(r) {
    return http.confirm.payload(`${BASE}/recalc`, r)
  },
  generateBizDate(r) {
    return http.confirm.post(`${BASE}/generateBizDate`, r)
  },
  /** 按日期范围初始化/补齐（默认幂等） */
  initByDateRange(r) {
    return http.confirm.payload(`${BASE}/initByDateRange`, r)
  },
  exportBill(r) {
    return http.spin.get(`${BASE}/exportBill`, r)
  },
}

export default stallBill
